// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20V8K","productName":"Table_productName__2AGMf"};